import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CdkDragDrop, moveItemInArray, CdkDrag } from '@angular/cdk/drag-drop';
import { BadgeOptions, badgeColorCode } from '../badge/badge.interface';

@Component({
  selector: 'app-task-reorder',
  templateUrl: './task-reorder.component.html',
  styleUrls: ['./task-reorder.component.scss']
})
export class TaskReorderComponent implements OnInit {

  tasks: any[] = [];
  arrangeableTask: any[] = [];
  disabledTask: any[] = [];
  constructor(
    public matDialogRef: MatDialogRef<TaskReorderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  drop(event: CdkDragDrop<unknown>): void {
    moveItemInArray(this.tasks, event.previousIndex, event.currentIndex);
  }

  sortPredicate(index: number, item: CdkDrag<number>): boolean {
    return index > (this.disabledTask?.length - 1);
  }

  closeModal(): void{
    this.matDialogRef.close();
  }

  rearrangeTask(): void {
    this.matDialogRef.close(this.tasks);
  }

  getBadgeOptions(task): BadgeOptions {
    const badgeOption: BadgeOptions = {
      type: 'TAG',
      color: badgeColorCode[task?.service_task_status],
      displayName: this.getServiceTaskStatusName(task?.service_task_status),
      extraClass: 'capitalize'
    };
    return badgeOption;
  }

  getServiceTaskStatusName(status: string): string{
    return status.split('_').join(' ').toLowerCase();
  }

  constructInitialTasks(tasks): void {
    tasks.forEach((task: any) => {
      if(!task?.service_task_status || task?.service_task_status === 'ON_HOLD' || task?.service_task_status === 'OPEN'){
        this.arrangeableTask.push(task);
      }else{
        this.disabledTask.push(task);
      };
    });
    this.tasks = [...this.disabledTask, ...this.arrangeableTask];
  }

  ngOnInit(): void {
    this.constructInitialTasks(this.data?.data?.data);
  }

}
